import { NgModule } from '@angular/core'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { CardModule } from 'primeng/card'

import { GenericModule } from '@app/components/generic/generic.module'

import { UpdateComponent } from './updates-detail'

@NgModule({
  imports: [
    SharedModule,
    ButtonModule,
    CardModule,
    GenericModule,
    UpdateComponent,
  ],
})
export class UpdatesModule {}
